'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RouteModalRootAuthenticated = require('../../components/modal/RouteModalRootAuthenticated');

var _RouteModalRootAuthenticated2 = _interopRequireDefault(_RouteModalRootAuthenticated);

var _AccountModalContainer = require('./AccountModalContainer');

var _AccountModalContainer2 = _interopRequireDefault(_AccountModalContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BACK_BUTTON_ROUTES = ['/account/payment', '/account/team', '/account/card', '/account/cancel'];

var AccountModalRoot = function AccountModalRoot(props) {
    return _react2.default.createElement(
        _RouteModalRootAuthenticated2.default,
        _extends({}, props, {
            className: 'auto-width',
            backButtonRoutes: BACK_BUTTON_ROUTES }),
        _react2.default.createElement(
            _AccountModalContainer2.default,
            props,
            props.children
        )
    );
};

AccountModalRoot.propTypes = {
    children: _propTypes2.default.node
};

exports.default = AccountModalRoot;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/AccountModalRoot.js
// module id = 2056
// module chunks = 0